import React from "react";

import { Export } from "./export";
import { ExportWizardModalProvider } from "./export_wizard";
import ManageReports from "./manage_reports";
import css from "./top_actions_panel.module.scss";

interface TopActionsPanelProps {
  shouldHideActionButtons: boolean;
}

export const TopActionsPanel = ({ shouldHideActionButtons }: TopActionsPanelProps): JSX.Element => (
  <ExportWizardModalProvider>
    <div className={css.root}>
      {!shouldHideActionButtons && <ManageReports />}
      {!shouldHideActionButtons && <Export />}
    </div>
  </ExportWizardModalProvider>
);
